import { useEffect,useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { api } from "/src/redux/api";
import Split from "react-split";
import TemplatePropertiesContainer from "/src/components/TemplateProperties/TemplatePropertiesContainer";
import OutboundPropertiesContainer from "/src/components/ItemProperties/OutboundPropertiesContainer";
import WorkflowGroupPanel from "/src/components/Panel/WorkflowGroupPanel";
import OutboundTemplatePanel from "/src/components/Panel/OutboundTemplatePanel ";
import { treeActions } from "../../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { cloneDeep } from "lodash";
import { getDataDepotObject } from "../../../utils/utilFunctions";
import WorkflowPropertiesContainer from "../../../components/ItemProperties/WorkflowPropertiesContainer";
import WorkflowTemplatePanel from "../../../components/Panel/WorkflowTemplatePanel";
import DocPanel from "../../../components/Panel/DocPanel";

function Workflow(props) {
  const parentScreen =  useContext(ParentScreenCtx);
  const dispatch = useDispatch();
  const { account, user, baseUrl, token } = useSelector((state) => state.queryParams);
  const { showDocFile } = useSelector(state => state.treeData.workflow)
  const treeData = useSelector(state => state.treeData);
  const currentTab  = useSelector(state => state.treeData[parentScreen].rightTree.currentTab)
  const selectedNode = useSelector(state => state.treeData[parentScreen].leftTree.tree.body.selectedNode);
  const rightSelectedNode = useSelector(state => state.treeData[parentScreen].rightTree.tree[currentTab].selectedNode);


  // On screen mount (or account/dispatch props are updated) make a request to get the inbound template list
  useEffect(() => {
    // Add a subscription to endpoint
    const copySelecteNode = cloneDeep(rightSelectedNode)
    const tab = currentTab
    dispatch(
      api.endpoints.getWorkflows.initiate(
        { account },
        { subscribe: false }
      )
    );
    // dispatch(
    //   treeActions.setLeftTreeContextActionValue({
    //     screen: parentScreen,
    //     data:{
    //       name: selectedNode.title,
    //       workflowGroup: selectedNode.workflowGroup,
    //       tabChanged: true 
    //     }
    //   })
    // );
    dispatch(treeActions.setRightTreeSelectedNode({screen: parentScreen, type: tab, data: copySelecteNode}));
    // dispatch(
    //   api.endpoints.getPdcList.initiate({
    //     account,
    //     direction: "out",
    //     datatype: "database",
    //   })
    // );
    if (!treeData.dataDepots) {
      getDataDepotObject({user, account, baseUrl, token},
        (obj) => {
          dispatch(treeActions.setDataDepotObj(obj));
        }
      );
    }
  }, [dispatch, account,props.val]); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="wbb-tab-container">
      {/* three horiz. panels split */}
      <Split
        className="split height-100 width-100 flex"
        direction="horizontal"
        gutterSize={4}
        snapOffset={0}
        dragInterval={4}
        sizes={[34, 66]}
      >
        {/* left panel- wfg tree and template properties vert. split*/}
        <div className="height-100">
          <Split
            style={{ height: "100%" }}
            className="split"
            direction="vertical"
            gutterSize={4}
            snapOffset={0}
            dragInterval={4}
            minSize={[100, 100]}
            maxSize={[500, 800]}
          >

            <WorkflowGroupPanel />
            <TemplatePropertiesContainer />
          </Split>
        </div>
        {showDocFile ? <DocPanel /> : null}
				{!showDocFile && (
					<Split
						gutterSize={4}
						snapOffset={0}
						className='split height-100 width-100 flex'
						direction='horizontal'
						sizes={[50, 50]}
					>
						<div className="height-100">
                <WorkflowPropertiesContainer />
              </div>
						<div id="rightTreePanel" className="height-100">
            <WorkflowTemplatePanel/>
          </div>
					</Split>
				)}
        
      </Split>
    </div>
  );
}

export default Workflow;
